import { Title } from '@/components/Elements/Title/Title';
import { SignupView } from '@/enums/SignupView';
import {
  InlineNotification,
  NotificationType,
  Button,
  TextInputField,
  Tooltip,
} from '@spotted-zebra-uk/ui-components';
import { useTranslation } from 'react-i18next';
import styles from './sign-up-selector.module.scss';
import { OrLine } from '@/components/Elements/OrLine/OrLine';
import { MicrosoftSSOButton } from '@/components/Views/Login/MicrosoftSSOButton/MicrosoftSSOButton';
import { CoBrandDetails } from '../CoBrandDetails/CoBrandDetails';
import clsx from 'clsx';
import { useAuthBranding } from '@/components/Providers/BrandingProvider/BrandingProvider';

export const SignUpSelector = ({
  email,
  setView,
}: {
  email: string;
  setView: (view: SignupView) => void;
}) => {
  const { t } = useTranslation();
  const projectCoBranding = useAuthBranding().branding;
  const hasCoBrandingEnabled = !!projectCoBranding;

  return (
    <>
      {hasCoBrandingEnabled && (
        <CoBrandDetails projectCoBranding={projectCoBranding} />
      )}
      <Title
        title={t('signUp.chooseMethod')}
        className={clsx(
          hasCoBrandingEnabled ? styles.titleCobranding : styles.title
        )}
        hasCobranding={hasCoBrandingEnabled}
        maintainSize={!hasCoBrandingEnabled}
      />
      <InlineNotification
        notificationType={NotificationType.NEUTRAL}
        className={styles.notification}
      >
        <div className={styles.notificationBody}>
          {t('signUp.chooseMethodNotif')}
        </div>
      </InlineNotification>
      <Tooltip content={t('signUp.emailLocked')}>
        <TextInputField
          id="email"
          label={t('forms.email')}
          placeholder={t('forms.email')}
          onChange={() => {}}
          disabled={true}
          value={email}
        />
      </Tooltip>
      <Button onClick={() => setView(SignupView.EMAIL_PASSWORD)} fullWidth>
        {t('signUp.signUpWithPassword')}
      </Button>
      <OrLine />
      <MicrosoftSSOButton
        onClick={() => setView(SignupView.SSO)}
        text={t('login.sso.signInWithMicrosoft')}
      />
    </>
  );
};
